import { StorageKeys } from './storageService';
export function getLastAccessedCompany() {
    return localStorage.getItem(StorageKeys.LastAccessedCompany);
}
export function saveLastAccessedCompany(companyId) {
    localStorage.setItem(StorageKeys.LastAccessedCompany, companyId);
}
export function clearLastAccessedCompany() {
    localStorage.removeItem(StorageKeys.LastAccessedCompany);
}
export function sortCompaniesByLastAccessed(companies, lastAccessedCompanyId) {
    if (!companies || companies.length === 0)
        return [];
    if (!lastAccessedCompanyId) {
        return [...companies].sort((a, b) => a.name.localeCompare(b.name, 'pt-BR'));
    }
    const lastAccessedCompany = companies.find(c => c.id === lastAccessedCompanyId);
    const otherCompanies = companies.filter(c => c.id !== lastAccessedCompanyId);
    const sortedOthers = otherCompanies.sort((a, b) => a.name.localeCompare(b.name, 'pt-BR'));
    return lastAccessedCompany ? [lastAccessedCompany, ...sortedOthers] : sortedOthers;
}
